var _rect, _rect2, _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDynamo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 150,
    viewBox: "0 0 230 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 230,
    height: 150,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 14,
    width: 13,
    height: 89,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.09 52.448C146.09 77.0247 153.302 99.084 136.22 103C103.514 103 77 83.0767 77 58.5C77 33.9233 103.514 14 136.22 14C154.441 14 146.09 27.8713 146.09 52.448Z",
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 150,
    cy: 58.5,
    rx: 5,
    ry: 33.5,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4101 107.745C74.1836 106.664 74.8764 105.604 75.9575 105.377L120.715 96L121.74 100.894L75.0253 110.681L74.4101 107.745Z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108C74 106.895 74.8954 106 76 106H77C78.1046 106 79 106.895 79 108V134C79 135.105 78.1046 136 77 136H76C74.8954 136 74 135.105 74 134V108Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamo);
export default __webpack_public_path__ + "static/media/Dynamo.cb44d78e64b2005a14054217295ae612.svg";
export { ForwardRef as ReactComponent };